var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TotalCosts',{attrs:{"data":_vm.data}}),_c('FulfilledOrderList',{staticClass:"fulfilled-orders-list",attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }